import {ForYouItem} from '../shared/ForYouItem'
import {decideChecksItem} from './shared/checks-item-decider'
import {useMergeabilityData} from './use-mergeability-data'
import {
  accessibleChecksSummary,
  checksSectionHeading,
} from '@github-ui/mergebox/components/sections/checks/checks-section-header-text'
import {OverviewMergeControl} from './shared/OverviewMergeControl'
import {useForYouActionErrors} from '../shared/use-for-you-action-errors'

// Renders when checks are still running and no workflow approval is pending
export function PendingChecks() {
  const {onQueueError, footer} = useForYouActionErrors()
  const data = useMergeabilityData()

  if (!data || decideChecksItem(data).kind !== 'pending') {
    return null
  }

  const {statusRollup, checksSection} = data
  // The merge box shares this summary without a final period; the item description is a sentence.
  const summary = accessibleChecksSummary(statusRollup.summary)

  return (
    <ForYouItem
      itemId="pending-checks"
      footer={footer}
      visual={{kind: 'spinner', tone: 'attention'}}
      title={checksSectionHeading[checksSection.sectionStatus]}
      subText={summary.endsWith('.') ? summary : `${summary}.`}
      actions={[
        {
          id: 'merge-when-ready',
          content: <OverviewMergeControl data={data} itemName="pending-checks" onQueueError={onQueueError} />,
        },
      ]}
    />
  )
}
